export default {
    data: () => ({
        disabledBtn: false
    }),
    computed: {
        getDisabledBtn() {
            return this.disabledBtn
        }
    }
}
